/* ============================================================================
   "Terug naar overzicht" op de productpagina: terug naar waar je vandaan kwam.
   ============================================================================

   HET PROBLEEM. De link staat in snippets/product-information-content.liquid en kiest zijn
   doel in Liquid, in deze volgorde:

     1. collection.url
     2. de eerste collectie uit product.collections die niet frontpage heet
     3. /collections/all

   Stap 1 werkt alleen als je het product via /collections/<handle>/products/<handle> opent.
   De productkaarten in dit thema linken naar /products/<handle>, zonder collectie, dus op de
   productpagina is het object `collection` leeg en valt hij altijd door naar stap 2. En
   product.collections heeft geen betekenisvolle volgorde. Vandaar dat je vanuit Lingerie op
   een body klikt en daarna in Voor haar - Bodys belandt.

   Een paginanummer kan Liquid sowieso niet weten. De server die de productpagina maakt heeft
   geen idee dat jij op pagina 3 van het overzicht stond. Dat moet dus wel aan deze kant.

   DE OPLOSSING. Op een overzichtspagina onthouden we het pad met de hele querystring. Daar
   zit alles in: ?page=3, de actieve filters en de sortering. Op de productpagina zetten we
   dat in de href van .pdp-back.

   Twee bronnen, in deze volgorde:
     1. sessionStorage, gezet toen de bezoeker op het overzicht stond. Dit is de betrouwbare
        route en overleeft ook een stap van product naar product, bijvoorbeeld via de
        aanbevelingen onderaan.
     2. document.referrer, als vangnet voor de eerste klik in een sessie waarin stap 1 nog
        niet gelukt is. Referrer kan door de browser of een privacy-instelling weggelaten
        zijn, daarom is dit niet de hoofdroute.

   Lukt geen van beide, dan blijft de href staan die Liquid al had gezet. Iemand die
   rechtstreeks via Google op een product binnenkomt houdt dus gewoon een werkende link.

   TERUG VIA DE GESCHIEDENIS. Kwam de bezoeker rechtstreeks van dat overzicht, dan laten we
   de klik door history.back() afhandelen in plaats van een nieuwe navigatie. Dat scheelt
   niet alleen een serververzoek: het thema zet bij terug/vooruit ook de scrollpositie terug
   (zie het herstelscript onderaan layout/theme.liquid). Je komt dan terug op precies de plek
   in het overzicht waar je klikte, in plaats van bovenaan pagina 3.

   In alle andere gevallen is het een doodgewone link, dus rechtermuisknop en openen in een
   nieuw tabblad blijven werken.
============================================================================ */
(function () {
  var SLEUTEL = 'pf-laatste-overzicht';

  /* Een overzicht is een collectiepagina of de zoekresultaten. */
  function isOverzicht(pad) {
    return pad.indexOf('/collections/') === 0 || pad === '/search';
  }

  /* Alleen een eigen pad accepteren. Geen //andere-host, geen volledige URL. */
  function isVeiligPad(waarde) {
    return typeof waarde === 'string' && waarde.charAt(0) === '/' && waarde.charAt(1) !== '/';
  }

  function onthoud(waarde) {
    try { sessionStorage.setItem(SLEUTEL, waarde); } catch (err) {}
  }

  function opgehaald() {
    try { return sessionStorage.getItem(SLEUTEL); } catch (err) { return null; }
  }

  /* Staan we op een overzicht, dan is er verder niets te doen: onthouden en klaar. */
  if (isOverzicht(location.pathname)) {
    onthoud(location.pathname + location.search);
    return;
  }

  var link = document.querySelector('.pdp-back');
  if (!link) return;

  /* Vangnet: kwam deze pagina rechtstreeks van een overzicht, dan is dat het doel, ook als
     sessionStorage nog leeg was. Meteen bewaren voor de volgende stap. */
  var viaReferrer = null;
  if (document.referrer) {
    try {
      var vorige = new URL(document.referrer);
      if (vorige.origin === location.origin && isOverzicht(vorige.pathname)) {
        viaReferrer = vorige.pathname + vorige.search;
        onthoud(viaReferrer);
      }
    } catch (err) {}
  }

  var doel = viaReferrer || opgehaald();
  if (!isVeiligPad(doel)) return;

  link.href = doel;

  link.addEventListener('click', function (e) {
    /* Laat elke klik met een toets erbij, of met een andere muisknop, gewoon de link volgen. */
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    /* Alleen terugstappen als de vorige pagina echt dit overzicht was. Anders landt
       history.back() ergens anders en dat is erger dan een gewone navigatie. */
    if (!document.referrer) return;
    var vorige;
    try { vorige = new URL(document.referrer); } catch (err) { return; }
    if (vorige.origin !== location.origin) return;
    if (vorige.pathname + vorige.search !== doel) return;

    e.preventDefault();
    history.back();
  });
})();
